import { Divider, Grid, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import globalStyles from "../../assets/styles/global.module.scss";
import headerStyles from '../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import GlobalPageHeaderText from '../../components/utility/globalPageHeaderText';
import styles from "../../assets/styles/componentStyles/apiKeyStyles/apiKeyStyle.module.scss";
import { GenericDataContext, GenericDataContextPayload } from '../../context/genericDataContext';
import { apiKeysBreadcrumb, dashboardBreadcrumb } from '../../utils/breadcrumb';
import { useApiKeyStore } from '../../store/apiKeyStore';
import { UserContext, UserContextPayload } from '../../context/userContext';
import ApiKeys from './components/apiKeys';

const ApiKeysGlobal = () => {

    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)');
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;
    const { setFlagLoading, handleError, userDetail } = useContext(UserContext) as UserContextPayload;

    const getApiKeyApi = useApiKeyStore((store) => store.getApiKeyApi);

    const getApiKey = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getApiKeyApi(userDetail);
        if (!(res.status)) {
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        const updatedBreadcrumbs = [
            { ...dashboardBreadcrumb },
            { ...apiKeysBreadcrumb, isActive: true }
        ];
        setBreadCrumbs(updatedBreadcrumbs);

        getApiKey(); // GET API Keys
    }, [])

    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${headerStyles.templateWrapper}`}>
                <Grid container className={globalStyles.headerGlobalPaddingStyle} direction={"column"} flexWrap={"nowrap"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container sx={{ alignItems: "center" }} direction={"column"}>
                            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.headerTextContainerStyle}`}>
                                <GlobalPageHeaderText
                                    mainHeadText={"API Keys"}
                                    flagMainTextOnly
                                />
                                {!smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle} ${styles.pageDivider}`} />}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} className={styles.pageOutlet}>
                        <ApiKeys
                            getApiKey={getApiKey}
                        />
                    </Grid>

                </Grid>
            </Grid>
        </>
    )
}

export default ApiKeysGlobal
